export const toPascalCase = (value: string): string => {
	return value
		.split(' ')
		.map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
		.join('');
};

/**
 * Calculates the distance between two points on the Earth specified by latitude and longitude.
 * @param origLat - Latitude of the first point in decimal degrees.
 * @param origLng - Longitude of the first point in decimal degrees.
 * @param targetLat - Latitude of the second point in decimal degrees.
 * @param targetLng - Longitude of the second point in decimal degrees.
 * @returns The distance between the two points in kilometers.
 */
export const calculateDistance = (origLat: number, origLng: number, targetLat: number, targetLng: number): number => {
	const R = 6371; // Radius of the Earth in kilometers
	const dLat = (targetLat - origLat) * (Math.PI / 180);
	const dLon = (targetLng - origLng) * (Math.PI / 180);

	const a =
		Math.sin(dLat / 2) * Math.sin(dLat / 2) +
		Math.cos(origLat * (Math.PI / 180)) * Math.cos(targetLat * (Math.PI / 180)) * Math.sin(dLon / 2) * Math.sin(dLon / 2);

	const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
	const distance = R * c; // Distance in kilometers

	return distance;
};
